import type { IProductionPartnerRepository, ProductionPartnerListQuery } from '@domain/data-contracts/production-partner-repository.interface';
import type { ProductionPartner } from '@domain/models/production-partner.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class ProductionPartnersService {
  public constructor(private readonly repo: IProductionPartnerRepository) {}

  public list(query: ProductionPartnerListQuery): Promise<PagedResult<ProductionPartner>> {
    return this.repo.list(query);
  }
}
